<template>

    <b-modal :id="`bv-modal-review-product-${page}`" hide-footer>

      <template #modal-title>Review product</template>
    
    <div class="row">
        <div class="col"><button type="button" :class="`select_btn ${selectedReject} col`" @click="selectOption('reject')">Reject</button></div>
        <div class="col"><button type="button" :class="`select_btn ${selectedApprove} col`" @click="selectOption('approve')">Approve</button></div>
    </div>

      <div v-if="selectedReject" class="row">
        <div class="col text-center">
            <div class="py-3"><small>Please enter a reason for rejecting</small></div>
            <input type="text" class="form-control2" v-model="product.reason">
        </div>
      </div>

      <div class="row pt-3 pb-2" v-if="selectedApprove || selectedReject">
        <div class="col">
            <button type="button" class="btn btn-secondary col" @click="hideModalReviewProduct()">Cancel</button>
        </div>
        <div class="col">
            <button v-if="updating" type="button" class="btn btn-danger col">
            <i class="fas fa-spinner fa-sm fa-spin mr-2 move-up"></i></button>
            <button v-else type="button" class="btn btn-danger submit col" @click="saveEmail">Submit</button>
        </div>
      </div>

    </b-modal>

</template> 

<script>
export default {
  props: ['product','page'],

  data() {
    return {
      updating: false,
      content: null,
      selectedReject: null,
      selectedApprove: null,
      apples: ['Incorrect image','Description too short'],
    };
  },

  methods: {

    selectOption(option) {
      if (option == 'reject') {
        this.selectedReject = 'selected';
        this.selectedApprove = null;
      } else {
        this.selectedApprove = 'selected';
        this.selectedReject = null;
      }
    },

    clearContent() {
      this.product.reason = null;
      this.selectedReject = null;
      this.selectedApprove = null;
    },

    hideModalReviewProduct() {
      this.$bvModal.hide(`bv-modal-review-product-${this.page}`);
    },

            saveEmail() {

              if (this.selectedReject && !this.product.reason) {this.sweetfire('Please choose a reason')}

            else {

              this.updating = true;

              axios.post('/products/review', {
                product_id: this.product.id,
                status: this.selectedReject ? 'Rejected' : 'Approved',
                reason: this.product.reason,
                })
                .then((response) => {

                  if (response.data.success) {
                    this.$emit('product-reviewed');
                    this.hideModalReviewProduct();
                    this.successAlert(response.data.message);
                    window.open('/products?tab=review', '_self');
                  } else {
                    this.sweetfire(response.data.message);
                  }

                  this.updating = false;

                });

          }

      },

      successAlert(text) {

        Swal.fire({
            title: text,
            customClass: {
                title: "popup-title",
                icon: 'custom-icon-size'
            },
            icon: 'success',
            showConfirmButton: false,
            timer: 3000,
            });
      },

      sweetfire(text) {

      Swal.fire({
      title: text,
      showConfirmButton: false,
      showDenyButton: false,
      showCancelButton: true,
      focusConfirm: false,
      cancelButtonText: 'Ok',
      customClass: {
              title: "popup-title",
            },
    })

    },
  },
};
</script>

<style scoped>
input.form-control, input.form-control:focus {
  border-radius: 5px !important;
}
.product_image { height:3rem; }
.review_button { background:rgb(255, 36, 36) !important;border-color:rgb(255, 36, 36) !important; }
.select_btn {
    padding: 7px 5px; 
    background: #fff; 
    color: #12161e; 
    border: 1px solid #12161e; 
    border-radius: 5px;
}

.selected {
    background: #12161e; 
    color: #fff;
    border: 1px solid #12161e; 
}
</style>